import { Directive, EventEmitter, HostBinding, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { _ } from '@ngx-translate/core';
import { I18nService } from 'app/services/i18n.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { filter, first, startWith } from 'rxjs/operators';
import { FormUtils } from '../classes/form-utils';

@Directive({ selector: '[onSubmit]' })
export class SubmitDirective implements OnDestroy {
  @Input() form: AbstractControl;
  @Input() validate: (form: AbstractControl) => Promise<boolean>;
  @Input() onSubmit: () => Observable<any> | Promise<Observable<any>>;
  @Input() disabled: boolean;
  @Input() successMessage: string = this._i18nService.translate(_('Dati salvati con successo'));
  @Input() errorMessage: string = this._i18nService.translate(_('Si è verificato un errore'));
  @Output() beforeSubmit: EventEmitter<void> = new EventEmitter<void>();
  @Output() afterSubmit: EventEmitter<void> = new EventEmitter<void>();
  @Output() afterError: EventEmitter<any> = new EventEmitter<any>();

  @HostBinding('class.onsubmit-loading') loading: boolean;
  @HostBinding('disabled') get btnDisabled(): boolean {
    return this.loading || this.disabled;
  }

  @HostListener('click', ['$event'])
  async onClick(event: MouseEvent) {
    // BEFORE SUBMIT BEHAVIOR
    this.beforeSubmit.next();

    if (typeof this.validate === 'function') {
      // CUSTOM VALIDATION
      if (!(await this.validate(this.form))) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    }

    if (this.form && this.form instanceof AbstractControl) {
      // SET LOADING FOR ASYNC VALIDATORS
      this.loading = true;
      // console.log('before validate status', this.form.status);
      // TRIGGER FIELDS VALIDATION
      FormUtils.validateAllFormFields(this.form);
      // console.log('after send validate status', this.form.status);
      // WAIT VALIDATORS TO COMPLETE

      if (this.form.invalid) {
        console.log('form', this.form);
        console.log('form errors', FormUtils.getInvalidFields(this.form));
      } else {
        console.log('form valid ???');
        console.log('form', this.form);
        console.log('form errors', FormUtils.getInvalidFields(this.form));
      }

      this.form.statusChanges
        .pipe(
          startWith(this.form.status),
          // startWith(''),
          filter((status) => status !== 'PENDING'),
          first(),
        )
        .subscribe((status) => {
          if (this.form.valid) {
            // SUBMIT
            this.submit();
          } else {
            // WARN AND REMOVE LOADER
            this._toastrService.error(this._i18nService.translate(_(`Controllare i campi obbligatori`)));
            this.loading = false;
            // PRINT ERRORS
            console.warn('form errors', FormUtils.getInvalidFields(this.form));
          }
        });
    } else {
      // console.log('direct submit');
      // PLAIN SUBMIT
      this.submit();
    }
  }

  constructor(
    private readonly _toastrService: ToastrService,
    private readonly _i18nService: I18nService,
  ) {}

  ngOnDestroy() {
    this.beforeSubmit.complete();
    this.afterSubmit.complete();
    this.afterError.complete();
  }

  async submit() {
    // console.log('submit clicked', this.onSubmit);

    let submitObservable: Observable<any> = await this.onSubmit();

    if (submitObservable && submitObservable instanceof Observable) {
      this.loading = true;
      setTimeout(() => {
        submitObservable
          .pipe(
            first(),
            // catchError(error => {
            //   if ()
            //   return throwError(error);
            // });
          )
          .subscribe({
            next: (response) => {
              // console.log('submit done', response);
              // AFTER SUBMIT BEHAVIOR
              this.loading = false;
              if (this.successMessage) {
                this._toastrService.success(this.successMessage);
              }
              this.afterSubmit.next(response);
            },
            error: (error: any) => {
              // SERVER ERROR
              this.loading = false;
              if (error && this.errorMessage) {
                console.log('submit error', error);
                this._toastrService.error(this.errorMessage);
              }
              this.afterError.next(error);
            },
          });
      });
    }
  }
}
